import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ckbr0ozf: FaireBrandEntity = {
  token: "b_ckbr0ozf",
  type: "brand",
  name: "LENORA Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/b1e8dfb85448d3f63cca7cf1d509ecda7c4fcd70a9eb882faf029d750851b304.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/afa783a51ab21a8e9b7883d42b5dbf3a57524425bc11993a5b2c0f9f5ca913c4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b1e8dfb85448d3f63cca7cf1d509ecda7c4fcd70a9eb882faf029d750851b304.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/afa783a51ab21a8e9b7883d42b5dbf3a57524425bc11993a5b2c0f9f5ca913c4.jpeg",
  location: "Superior, WI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "LENORA Organics is inspired by my Norwegian Grandmother, Lenora - a woman remembered for her kindness and grace. She taught me the importance of self-care at a very young age. Her spirit continues to shine through every product we make.\n\nAll LENORA products are crafted in small batches on the beautiful shores of Lake Superior in Superior, Wisconsin. We believe in using simple, effective, certified organic ingredients that are gentle on both the skin and the planet.\n\nSustainability is at the heart of our brand. We thoughtfully package our products in glass jars, bottles, and paperboard containers, always striving to reduce our carbon footprint and protect our environment. \n\nAt LENORA, we also believe that self-care + slow living is essential. When your mind and spirit are nurtured, you’re better able to care for those around you. \n\nWe’re proud to be part of an incredible community and love giving back by supporting our local shelter, which provides meals, housing, and job assistance to those in need.\n\nI hope you you love LENORA. \n\nJenn ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:31.768Z",
    importedBy: "entity-db-cli",
  },
};
